import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import QuickViewPool from '@play-co/timestep-core/lib/ui/ViewPool2';

const SPARKLE_IMAGE = 'assets/ui/buddies/common/sparkle.png';
const SPARKLE_SIZE = 40;

const FADE_IN = 500;
const FADE_OUT = 500;
const LIFETIME = FADE_IN + FADE_OUT;

const SPAWN_INTERVAL = 100;
const MIN_SPEED = 0.02;
const MAX_SPEED = 0.09;
const MIN_SCALE = 0.5;
const MAX_SCALE = 0.9;

type Particle = {
  view: ImageScaleView;
  time: number;
  speed: number;
};

export class BuddiesSparkles extends View {
  private pool: QuickViewPool<ImageScaleView>;
  private particles: Particle[] = [];
  private spawnTimer = 0;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
      canHandleEvents: false,
    });

    this.pool = new QuickViewPool(
      () =>
        new ImageScaleView({
          superview: this,
          image: SPARKLE_IMAGE,
          width: SPARKLE_SIZE,
          height: SPARKLE_SIZE,
          scaleMethod: 'contain',
          centerOnOrigin: true,
          centerAnchor: true,
          opacity: 0,
        }),
    );
  }

  private spawn() {
    const view = this.pool.obtainView();
    const scale = MIN_SCALE + Math.random() * (MAX_SCALE - MIN_SCALE);
    const speed = MIN_SPEED + Math.random() * (MAX_SPEED - MIN_SPEED);

    view.updateOpts({
      x: Math.random() * this.style.width,
      y: Math.random() * this.style.height,
      scale,
      opacity: 0,
      visible: true,
    });

    this.particles.push({ view, time: 0, speed });
  }

  public tick(dt: number) {
    // Spawn new particles
    this.spawnTimer += dt;
    while (this.spawnTimer >= SPAWN_INTERVAL) {
      this.spawnTimer -= SPAWN_INTERVAL;
      this.spawn();
    }

    // Update active particles
    for (let i = this.particles.length - 1; i >= 0; i--) {
      const p = this.particles[i];
      p.time += dt;

      // Move upward
      p.view.style.y -= p.speed * dt;

      // Fade in then fade out
      if (p.time < FADE_IN) {
        p.view.style.opacity = p.time / FADE_IN;
      } else {
        p.view.style.opacity = 1 - (p.time - FADE_IN) / FADE_OUT;
      }

      // Release when done
      if (p.time >= LIFETIME) {
        this.pool.releaseView(p.view);
        this.particles.splice(i, 1);
      }
    }
  }
}
